<div class="col-span-12 lg:col-span-6 xl:col-span-3 mr-3 md:mr-0">
    <div class="card mb-0">
        <div class="flex justify-between mb-4">
            <div>
                <span class="block text-muted-color font-medium mb-4">Probabilités vues</span>
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">{{this.viewedPredictions()?.viewed_predictions_count || 0}}</div>
            </div>
            <div class="flex items-center justify-center bg-blue-100 dark:bg-blue-400/10 rounded-border" style="width: 2.5rem; height: 2.5rem">
                <i class="pi pi-chart-bar text-blue-500 !text-xl"></i>
            </div>
        </div>

    </div>
</div>
<div class="col-span-12 lg:col-span-6 xl:col-span-3 mr-3 md:mr-0">
    <div class="card mb-0">
        <div class="flex justify-between mb-4">
            <div>
                <span class="block text-muted-color font-medium mb-4">Confiance moyenne</span>
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">{{ getAveragePlatformRoi() }}%</div>
            </div>
            <div class="flex items-center justify-center bg-orange-100 dark:bg-orange-400/10 rounded-border" style="width: 2.5rem; height: 2.5rem">
                <i class="pi pi-star text-orange-500 !text-xl"></i>
            </div>
        </div>

    </div>
</div>
<div class="col-span-12 lg:col-span-6 xl:col-span-3 mr-3 md:mr-0">
    <div class="card mb-0">
        <div class="flex justify-between mb-4">
            <div>
                <span class="block text-muted-color font-medium mb-4">Abonnement restant</span>
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">{{subscriptionDaysLeft()}} jours</div>
            </div>
            <div class="flex items-center justify-center bg-cyan-100 dark:bg-cyan-400/10 rounded-border" style="width: 2.5rem; height: 2.5rem">
                <i class="pi pi-clock text-cyan-500 !text-xl"></i>
            </div>
        </div>
    </div>
</div>
<div class="col-span-12 lg:col-span-6 xl:col-span-3 mr-3 md:mr-0">
    <div class="card mb-0">
        <div class="flex justify-between mb-4">
            <div>
                <span class="block text-muted-color font-medium mb-4">Dernière analyse</span>
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">{{detailsLastPredictions() || 'Aucune analyse consultée'}}</div>
            </div>
            <div class="flex items-center justify-center bg-purple-100 dark:bg-purple-400/10 rounded-border" style="width: 2.5rem; height: 2.5rem">
                <i class="pi pi-eye text-purple-500 !text-xl"></i>
            </div>
        </div>
    </div>
</div>
